/**
 * Main layout wrapper for the application
 */
import FileExplorer from '../features/FileExplorer';
import Content from '../features/Content';
import '../../index.css';

const MainLayout = () => {
  return (
    <div className="App">
      <FileExplorer />
      <Content />
    </div>
  );
};

export default MainLayout;
